<template>
  <v-container fluid fill-height pa-0 :class="$style.root">
    <TrafficMessageRevisionSelect v-if="$route.name === 'HistoryEvent'" />

    <v-row class="fill-height">
      <v-col cols="5" class="pa-0">
        <TrafficMessageForm />
      </v-col>
      <v-col :class="$style.borderVertical" class="pa-0">
        <TrafficMessagePreview />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { get } from 'vuex-pathify'
import TrafficMessageForm from './TrafficMessageForm'
import TrafficMessagePreview from './TrafficMessagePreview'
import TrafficMessageRevisionSelect from './TrafficMessageRevisionSelect'

export default {
  name: 'TrafficMessageContainer',

  components: {
    TrafficMessageForm,
    TrafficMessagePreview,
    TrafficMessageRevisionSelect
  },

  computed: {
    event: get('event/selectedEvent')
  }
}
</script>

<style lang="scss" module>
.root {
  height: calc(100vh - 334px);
}

.borderVertical {
  border-left: 1px solid rgba(#000, 0.12);
}
</style>
